import './styles.scss';

export default {
    name: 'StampDropdown',

    data() {
        return {
            stamps: [],
            current: ''
        }
    },

    methods: {
        chooseStamp(stamp) {
            this.current = stamp.id;
            this.$ionic.popoverController.dismiss(stamp);
        },
    }
}; 